
const $761f97bf09d51d3e$var$container = document.querySelector(".container");
const $761f97bf09d51d3e$var$messageContainer = document.querySelector(".message");
const $761f97bf09d51d3e$var$resetButton = document.querySelector(".reset");
const $761f97bf09d51d3e$var$winningOptions = [
    [
        0,
        1,
        2
    ],
    [
        3,
        4,
        5
    ],
    [
        6,
        7,
        8
    ],
    [
        0,
        3,
        6
    ],
    [
        1,
        4,
        7
    ],
    [
        2,
        5,
        8
    ],
    [
        0,
        4,
        8
    ],
    [
        2,
        4,
        6
    ]
];
let $761f97bf09d51d3e$var$selected = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
];
let $761f97bf09d51d3e$var$player = "X";
let $761f97bf09d51d3e$var$isGameOver;
function $761f97bf09d51d3e$var$resetGame() {
    $761f97bf09d51d3e$var$selected = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ];
    $761f97bf09d51d3e$var$player = "X";
    $761f97bf09d51d3e$var$isGameOver = false;
    $761f97bf09d51d3e$var$messageContainer.innerText = "";
    console.log($761f97bf09d51d3e$var$container.getElementsByClassName("item"));
    const items = $761f97bf09d51d3e$var$container.querySelectorAll(".item");
    items.forEach((element)=>{
        element.innerText = "";
    });
}
function $761f97bf09d51d3e$var$checkGameStatus() {
    for (var option of $761f97bf09d51d3e$var$winningOptions){
        const cellA = $761f97bf09d51d3e$var$selected[option[0]];
        const cellB = $761f97bf09d51d3e$var$selected[option[1]];
        const cellC = $761f97bf09d51d3e$var$selected[option[2]];
        if (cellA == "" || cellB == "" || cellC == "") continue;
        if (cellA == cellB && cellB == cellC) {
            $761f97bf09d51d3e$var$isGameOver = true;
            break;
        }
    }
    if ($761f97bf09d51d3e$var$isGameOver) $761f97bf09d51d3e$var$setBannerMessage(`Winner is ${$761f97bf09d51d3e$var$player}`);
    else if (!$761f97bf09d51d3e$var$selected.includes("")) $761f97bf09d51d3e$var$setBannerMessage(`Draw`);
    else {
        $761f97bf09d51d3e$var$player = $761f97bf09d51d3e$var$player == "X" ? "O" : "X";
        $761f97bf09d51d3e$var$setBannerMessage(`${$761f97bf09d51d3e$var$player} is your turn`);
    }
}
function $761f97bf09d51d3e$var$setBannerMessage(message) {
    $761f97bf09d51d3e$var$messageContainer.innerText = message;
}
function $761f97bf09d51d3e$var$cellClick(e) {
    const selectedCell = e.target;
    if (!selectedCell.dataset.cell || $761f97bf09d51d3e$var$isGameOver) return;
    selectedCell.innerText = $761f97bf09d51d3e$var$player;
    $761f97bf09d51d3e$var$selected[selectedCell.dataset.cell] = $761f97bf09d51d3e$var$player;
    $761f97bf09d51d3e$var$checkGameStatus();
}
function $761f97bf09d51d3e$var$init() {
    $761f97bf09d51d3e$var$container.addEventListener("click", $761f97bf09d51d3e$var$cellClick);
    $761f97bf09d51d3e$var$resetButton.addEventListener("click", $761f97bf09d51d3e$var$resetGame);
}
$761f97bf09d51d3e$var$init();


//# sourceMappingURL=path0.2e2fb9ed.js.map
